import { Pressable } from "react-native";
import { Circle, useMedia, View, XStack } from "tamagui";
import type {
  BusinessPlanModel,
  BusinessStaticUserInfoWithUserUid,
} from "../business/plan/BusinessPlanModel";
import { Permission } from "../permissions/types";
import { Label } from "./Label";
import { AvatarSize, AvatarSizeLookup, UserPropsAvatar } from "./UserAvatar";

type Props = {
  businessPlan?: BusinessPlanModel;
  users: BusinessStaticUserInfoWithUserUid[];
  size?: AvatarSize;
  onPress?: () => void;
  skipPadding?: boolean;
};

const MAX_USERS = 7;
const OVERLAP_PIXELS = 8;

export const UserAvatarGroupRaw = ({
  businessPlan,
  users,
  onPress,
  skipPadding,
}: Props) => {
  const usersMoreToShow = Math.max(0, users.length - MAX_USERS);
  const usersToShow = users.slice(0, MAX_USERS);
  const media = useMedia();

  const size = media.gtSm ? AvatarSize.Medium : AvatarSize.Small;
  const sizeInPx = AvatarSizeLookup[size];

  return (
    <Pressable disabled={!onPress} onPress={onPress}>
      <View
        paddingHorizontal={skipPadding ? undefined : "$larger"}
        $gtSm={{ paddingHorizontal: 0 }}
      >
        <XStack width={"100%"} height={sizeInPx}>
          {usersToShow.map((d, i) => {
            return (
              <View
                key={d.userUid}
                position="absolute"
                left={(sizeInPx - OVERLAP_PIXELS) * i}
                zIndex={i + 1}
              >
                <UserPropsAvatar
                  displayName={d.displayName}
                  avatarUrl={d.avatarUrl}
                  size={size}
                  showBorder={businessPlan?.checkPermission(
                    Permission.AvatarShowExtraBorder,
                    d.userUid,
                  )}
                />
              </View>
            );
          })}

          {usersMoreToShow > 0 && (
            <Circle
              size={sizeInPx}
              backgroundColor={"$divider"}
              position="absolute"
              left={(sizeInPx - OVERLAP_PIXELS) * usersToShow.length}
              zIndex={MAX_USERS + 1}
            >
              <Label>+{usersMoreToShow}</Label>
            </Circle>
          )}
        </XStack>
      </View>
    </Pressable>
  );
};
